module.exports = __webpack_public_path__ + "static/article-image-3ea6c5a7a276266b31d2d5a1ba5cdcc8.jpeg";